<section class="vehicle-page">
  <header class="vehicle-header">
    <img class="brand-logo" src="assets/dashboard/logoApp.svg" alt="AutoInsight logo" />
    <div class="header-title-wrap">
      <button
        *ngIf="viewMode === 'profiles'"
        class="back-btn"
        type="button"
        aria-label="Back to dashboard"
        (click)="backToDashboard()">
        &#8592;
      </button>
      <button
        *ngIf="viewMode === 'add'"
        class="back-btn"
        type="button"
        aria-label="Back"
        (click)="backFromAddFlow()">
        &#8592;
      </button>
      <h1>{{ viewMode === 'profiles' ? 'Vehicle Profiles' : 'Add Vehicle' }}</h1>
    </div>
    <button *ngIf="viewMode === 'profiles'" class="logout-btn" type="button" (click)="logout()">Log Out</button>
    <span *ngIf="viewMode === 'add'" class="header-spacer" aria-hidden="true"></span>
  </header>

  <main class="vehicle-main">
    <div *ngIf="viewMode === 'profiles' && loading" class="state">Loading vehicle profiles...</div>
    <div *ngIf="viewMode === 'profiles' && !loading && errorMessage" class="state error">
      <p>{{ errorMessage }}</p>
      <button class="retry-btn" type="button" (click)="loadVehicles(selectedVehicleId)">Retry Load</button>
    </div>

    <section *ngIf="viewMode === 'profiles'" class="profiles-view">
      <section class="vehicle-list" *ngIf="!loading && vehicles.length > 0">
        <button
          *ngFor="let vehicle of vehicles"
          type="button"
          class="vehicle-card"
          [class.active]="vehicle.id === selectedVehicleId"
          (click)="selectVehicle(vehicle.id)">
          <div class="vehicle-image-frame">
            <img
              class="vehicle-image"
              [src]="vehicleImageFor(vehicle.make, vehicle.model)"
              [alt]="vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model" />
          </div>
          <h2>{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</h2>
          <p>Mileage: {{ vehicle.currentOdometerKm | number }} KM</p>
        </button>
      </section>

      <section class="state warning" *ngIf="!loading && vehicles.length === 0">
        No vehicles were found for this account. Add one below to continue.
      </section>

      <section class="action-stack">
        <button class="btn btn-primary action-main" type="button" (click)="continueToDashboard()" [disabled]="selectedVehicleId === null">
          Select Vehicle
        </button>
        <button
          class="btn btn-danger action-medium"
          type="button"
          (click)="deleteSelectedVehicle()"
          [disabled]="selectedVehicleId === null || deleting">
          Delete Vehicle
        </button>
      </section>

      <section class="sub-actions">
        <button class="btn btn-secondary action-medium" type="button" (click)="openAddVehicle()">
          Add Vehicle
        </button>
      </section>
    </section>

    <section *ngIf="viewMode === 'add'" class="add-view">
      <p class="owner-id">Owner: {{ ownerId }}</p>

      <p class="form-status form-info" *ngIf="vehicleMatchMessage">{{ vehicleMatchMessage }}</p>

      <ng-container *ngIf="addStep === 'make'">
        <section class="make-grid-panel">
          <button
            *ngFor="let make of makeOptions"
            class="make-tile"
            type="button"
            [class.active]="selectedMakeCandidate === make"
            (click)="selectMake(make)">
            <span>{{ make }}</span>
          </button>
        </section>

        <section class="step-actions">
          <button class="btn btn-primary action-main" type="button" (click)="confirmMakeSelection()" [disabled]="matchingVehicle">
            Select Make
          </button>
        </section>

        <p class="or-label">Or enter VIN</p>
        <label class="vin-row">
          <span>VIN</span>
          <input type="text" name="vinStepMake" [(ngModel)]="form.vin" maxlength="32" placeholder="e.g. 2HGFC2F69L1234567" />
        </label>

        <section class="step-actions">
          <button class="btn btn-secondary action-sub action-match action-vin-large" type="button" (click)="matchVehicleFromInput()" [disabled]="matchingVehicle">
            {{ matchingVehicle ? 'Selecting...' : 'Select by VIN' }}
          </button>
        </section>
        <p class="form-status form-error" *ngIf="errorMessage">{{ errorMessage }}</p>
      </ng-container>

      <ng-container *ngIf="addStep === 'model'">
        <section class="vehicle-list model-list" *ngIf="modelOptionsForSelectedMake.length > 0">
          <button
            *ngFor="let modelOption of modelOptionsForSelectedMake"
            type="button"
            class="vehicle-card"
            [class.active]="selectedModelCandidate?.model === modelOption.model"
            (click)="selectModelOption(modelOption)">
            <div class="vehicle-image-frame">
              <img
                class="vehicle-image"
                [src]="'assets/vehicles/' + modelOption.imageType + '.svg'"
                [alt]="modelOption.make + ' ' + modelOption.model" />
            </div>
            <h2>{{ modelOption.year }} {{ modelOption.make }} {{ modelOption.model }}</h2>
            <p *ngIf="modelOption.trim">{{ modelOption.trim }}</p>
          </button>
        </section>

        <section *ngIf="modelOptionsForSelectedMake.length === 0" class="manual-model-panel">
          <label>
            Model
            <input type="text" name="manualModel" [(ngModel)]="form.model" maxlength="60" />
          </label>
          <label>
            Year
            <input type="number" name="manualYear" [(ngModel)]="form.year" min="1886" max="2200" step="1" />
          </label>
        </section>

        <section class="step-actions">
          <button class="btn btn-primary action-main" type="button" (click)="confirmModelSelection()" [disabled]="matchingVehicle">
            Select Model
          </button>
        </section>

        <p class="or-label">Or enter VIN</p>
        <label class="vin-row">
          <span>VIN</span>
          <input type="text" name="vinStepModel" [(ngModel)]="form.vin" maxlength="32" placeholder="e.g. 2HGFC2F69L1234567" />
        </label>

        <section class="step-actions">
          <button class="btn btn-secondary action-sub action-match action-vin-large" type="button" (click)="matchVehicleFromInput()" [disabled]="matchingVehicle">
            {{ matchingVehicle ? 'Selecting...' : 'Select by VIN' }}
          </button>
          <button class="btn btn-secondary action-sub action-match action-vin-large" type="button" (click)="restartMakeSelection()">Change Make</button>
        </section>
        <p class="form-status form-error" *ngIf="errorMessage">{{ errorMessage }}</p>
      </ng-container>

      <ng-container *ngIf="addStep === 'details'">
        <section class="details-layout">
          <article class="preview-column">
            <div class="vehicle-image-frame preview-frame">
              <img class="vehicle-image" [src]="vehicleImageFor(form.make, form.model)" [alt]="addVehicleTitle" />
            </div>
            <h2>{{ addVehicleTitle }}</h2>
            <p>{{ addVehicleSubtitle }}</p>
            <div class="preview-actions">
              <button class="btn btn-secondary action-sub preview-action" type="button" (click)="restartModelSelection()">Change Model</button>
              <button class="btn btn-secondary action-sub preview-action" type="button" (click)="restartMakeSelection()">Change Make</button>
            </div>
          </article>

          <article class="details-panel">
            <label>
              <span>Mileage</span>
              <input type="number" name="currentOdometerKm" [(ngModel)]="form.currentOdometerKm" min="0" step="1" />
            </label>

            <h3>Initial Part Durability by Mileage</h3>

            <label>
              <span>Oil Filter</span>
              <input type="number" name="oilFilterKm" [(ngModel)]="form.oilFilterKm" min="0" step="1" />
            </label>
            <label>
              <span>Engine Oil</span>
              <input type="number" name="engineOilKm" [(ngModel)]="form.engineOilKm" min="0" step="1" />
            </label>
            <label>
              <span>Spark Plugs</span>
              <input type="number" name="sparkPlugsKm" [(ngModel)]="form.sparkPlugsKm" min="0" step="1" />
            </label>
            <label>
              <span>Brake Pads</span>
              <input type="number" name="brakePadsKm" [(ngModel)]="form.brakePadsKm" min="0" step="1" />
            </label>
            <label>
              <span>Cabin Air Filter</span>
              <input type="number" name="cabinAirFilterKm" [(ngModel)]="form.cabinAirFilterKm" min="0" step="1" />
            </label>
            <label>
              <span>Engine Air Filter</span>
              <input type="number" name="engineAirFilterKm" [(ngModel)]="form.engineAirFilterKm" min="0" step="1" />
            </label>
            <label>
              <span>Fuel Filter</span>
              <input type="number" name="fuelFilterKm" [(ngModel)]="form.fuelFilterKm" min="0" step="1" />
            </label>
          </article>
        </section>

        <button class="btn btn-primary action-main add-profile-btn" type="button" (click)="addVehicle()" [disabled]="saving">
          {{ saving ? 'Adding...' : 'Add Profile' }}
        </button>
        <p class="form-status form-error" *ngIf="errorMessage">{{ errorMessage }}</p>
      </ng-container>
    </section>
  </main>
</section>
